import { TasteProfileData } from '../types/profile';

export function normalizeTasteProfile(data: Partial<TasteProfileData>): TasteProfileData {
  return {
    // Region & Personalization (NEW)
    regionCountry: data.regionCountry ?? 'US',
    regionCurrency: data.regionCurrency ?? 'USD', 
    reasons: data.reasons ?? [],
    
    dietType: data.dietType ?? '',
    allergies: data.allergies ?? [],
    dietaryRestrictions: data.dietaryRestrictions ?? [],
    likes: data.likes ?? [],
    dislikes: data.dislikes ?? [],
    primaryGoal: data.primaryGoal ?? '',
    macroTargets: data.macroTargets ?? { protein: 150, carbs: 200, fat: 65, calories: 2000 },
    householdSize: data.householdSize ?? 1,
    availableEquipment: data.availableEquipment ?? [],
    batchPrepPreference: data.batchPrepPreference ?? '',
    spiceLevel: data.spiceLevel ?? '',
    cookingTime: data.cookingTime ?? '',
    pantryStaples: data.pantryStaples ?? [],
    favoriteCuisines: data.favoriteCuisines ?? [],
    favoriteIngredients: data.favoriteIngredients ?? [],
    // NEW: Meal Planning Preferences defaults
    mealTypes: data.mealTypes ?? ['dinner'],
    budgetRange: data.budgetRange ?? 'moderate',
    cookingDifficulty: data.cookingDifficulty ?? 'intermediate',
    unitSystem: data.unitSystem ?? 'imperial',
    temperatureUnit: data.temperatureUnit ?? 'fahrenheit',
    volumeUnit: data.volumeUnit ?? 'cups',
    weightUnit: data.weightUnit ?? 'pounds',
    emailPreferences: data.emailPreferences ?? {
      weeklyDigest: true, recipeSuggestions: true, shoppingReminders: false, seasonalUpdates: true
    },
    notificationSettings: data.notificationSettings ?? {
      pushNotifications: true, emailNotifications: true, smsNotifications: false
    },
    tasteProfile: data.tasteProfile ?? {
      spiceTolerance: 5, sweetnessPreference: 5, complexityLevel: 5,
      texturePreferences: [], cookingMethods: []
    },
    completedSteps: data.completedSteps ?? [],
    lastUpdated: data.lastUpdated ?? new Date(),
  };
}